var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pd-t170 main-column theme-style-01",attrs:{"id":"main-column"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }